// extracted by mini-css-extract-plugin
module.exports = {"default":"global_default__2xXq3","mainContainer":"global_mainContainer__JtaLw","hidden":"global_hidden__bfff0"};